import { FunnelMetadata } from 'generated/types'

import { IS_DYNAMIC_FUNNEL_ENABLED, METADATA_KEY } from './index'

export const isDynamicFunnelEnabled = (): boolean => {
  return window.sessionStorage.getItem(IS_DYNAMIC_FUNNEL_ENABLED) === 'true'
}

export const retrieveMetadata = (): FunnelMetadata => {
  return JSON.parse(window.sessionStorage.getItem(METADATA_KEY))
}
